module.exports = __webpack_public_path__ + "static/media/Scragg Jockey Pulley.0fbe41fb.jpg";